export default "__VITE_ASSET__c9f55021__"